import { keyBy } from 'lodash';

import {
  GET_CITIES,
  GET_CITIES_FAILED,
  GET_CITIES_SUCCESS,
} from "../actions/cityManagement.action";

const INITIAL_STATE = {
  cities: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function cityReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CITIES:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_CITIES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        cities: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_CITIES_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
